/*
 * @Author: Teemo Ding
 * @Date: 2022-05-05 10:15:45
 * @LastEditTime: 2022-05-06 08:11:48
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/analytics/reportSubscription.ts
 */
import { get, post } from 'src/tools/server';

export const reportSubscriptionList = (startIndex, pageCount, data) => {
  return post<any>(
    `portal/report/subscription/list/${startIndex}/${pageCount}`,
    data,
    {},
  );
};

export const reportSubscriptionSave = (data) => {
  return post<any>(`portal/report/subscription/save`, data, {});
};

export const reportSubscriptionDelete = (data) => {
  return post<any>(`portal/report/subscription/delete`, data, {});
};

export const createReportSubscription = () => {
  return get<any>(`portal/report/subscription/createPage`, {});
};
export const initReportSubscription = (subscriptionUuid) => {
  return get<any>(`portal/report/subscription/${subscriptionUuid}`, {});
};

export const getNextSendTime = (data) => {
  return post<any>(`portal/report/subscription/nextSendTime`, data, {});
};
